import { render, staticRenderFns } from "./TemaNuevo.vue?vue&type=template&id=05a7c650&"
import script from "./TemaNuevo.vue?vue&type=script&lang=js&"
export * from "./TemaNuevo.vue?vue&type=script&lang=js&"
import style0 from "./TemaNuevo.vue?vue&type=style&index=0&id=05a7c650&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports